// pages/src/components/common/EnterpriseModal.tsx
import React, { useState } from 'react';
import { Modal, Box, Typography, TextField, Button, Slider, useTheme, useMediaQuery } from '@mui/material';

interface EnterpriseModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (quantity: number, organizationName: string) => Promise<void>;
}

const EnterpriseModal: React.FC<EnterpriseModalProps> = ({ open, onClose, onSave }) => {
  const [quantity, setQuantity] = useState(1);
  const [organizationName, setOrganizationName] = useState('');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleSave = async () => {
    await onSave(quantity, organizationName);
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isMobile ? 300 : 400,
        bgcolor: 'background.paper',
        border: '1px solid #555',
        borderRadius: 2,
        boxShadow: 24,
        p: 4,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}>
        <Typography variant="h6" component="h2">
          Enterprise Subscription
        </Typography>
        <TextField
          fullWidth
          label="Organization Name"
          value={organizationName}
          onChange={(e) => setOrganizationName(e.target.value)}
        />
        <Typography gutterBottom>
          Quantity: {quantity}
        </Typography>
        <Slider
          value={quantity}
          onChange={(_, newValue) => setQuantity(newValue as number)}
          aria-labelledby="quantity-slider"
          valueLabelDisplay="auto"
          step={1}
          marks
          min={1}
          max={500}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2 }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="contained" onClick={handleSave} disabled={!organizationName}>
            Save
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default EnterpriseModal;